import 'babel-polyfill';
import ReactDOM from "react-dom";
import promiseFinally from "promise.prototype.finally";
import React from "react";
import { HashRouter } from "react-router-dom";
import { useStrict } from "mobx";
import { Provider } from "mobx-react";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import  CssBaseline from "@material-ui/core/CssBaseline";
import App from "./components/App";
import authStore from "./stores/authStore";
import commonStore from "./stores/commonStore";

const stores = {
  authStore,
  commonStore
};

// For easier debugging
window._____APP_STATE_____ = stores;

promiseFinally.shim();
useStrict(true);

/*const theme = createMuiTheme({
  palette: {
    type: 'dark',
    background: {
      default: "#CACDCD"
    },
  },
});*/

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#66FCF1',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#66FCF1',
      main: '#0B0C10',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#45A29E',
    },
    // error: will use the default color
  },
  overrides:{
    MuiTooltip: {
      tooltip: {
        border: '1px solid #66FCF1',
        color:'#FFFFFF',
        fontSize: 16

      },
    },
  }
});

/*
interface PaletteIntention {
  light?: 'C5C6C7';
  main:'0B0C10';
  dark?: '1F2833';
  contrastText?: '66FCF1';
};*/

ReactDOM.render(

  <Provider {...stores}>
    <HashRouter>
    <MuiThemeProvider theme={theme}>
    <CssBaseline />
      <App />
      </MuiThemeProvider>
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);


// WEBPACK FOOTER //
// ./src/index.js